import React, { Component } from 'react';

import { reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import FlatButton from 'material-ui/FlatButton';

import * as validator from 'helpers/Validator';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';

class LogoUploaderForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpdateLogoButton: false,
    };
  }

  onFileChanged = filesToUpload => {
    if (typeof filesToUpload === 'string' && filesToUpload === 'removed') {
      this.setState({ showUpdateLogoButton: false });
    } else if (Array.isArray(filesToUpload)) {
      this.setState({ showUpdateLogoButton: true });
    }
  };

  submit = () => {
    // handleSubmit is a promise only if the handleSubmit call is successful
    // other handleSubmit will return an error object.
    const submitResponse = this.props.handleSubmit();
    if (submitResponse.then) {
      submitResponse.then(() => {
        this.setState({ showUpdateLogoButton: false });
      });
    }
  };

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <div
          className="row"
          style={{
            marginTop: '15px',
            textAlign: 'justify',
            fontSize: '14px',
            marginBottom: '15px',
          }}
        >
          {this.props.description}
        </div>
        <div className="row" style={{ marginTop: '15px', marginBottom: '15px' }}>
          <div className="col-sm-12">
            {this.props.required ? (
              <Field
                name={this.props.name}
                validate={[validator.required]}
                style={{
                  border: `1px dashed ${colors.LIGHT_GRAY}`,
                  width: '60%',
                  margin: 'auto',
                  textAlign: 'center',
                }}
                labelText={this.props.labelText}
                component={ReduxDropzone}
                fileValidation={this.props.fileValidation || 'image/*'}
                size={120}
                fileChanged={this.onFileChanged}
              />
            ) : (
              <Field
                name={this.props.name}
                style={{
                  border: `1px dashed ${colors.LIGHT_GRAY}`,
                  width: '60%',
                  margin: 'auto',
                  textAlign: 'center',
                }}
                labelText={this.props.labelText}
                component={ReduxDropzone}
                fileValidation="image/*"
                size={120}
                fileChanged={this.onFileChanged}
              />
            )}
          </div>
        </div>
        <div className="row" style={{ textAlign: 'center', marginBottom: '15px' }}>
          {this.state.showUpdateLogoButton && (
            <FlatButton
              variant="raised"
              disabled={this.props.submitting}
              onClick={this.submit}
              style={{
                color: 'white',
                backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
              }}
            >
              UPDATE
            </FlatButton>
          )}
        </div>
      </form>
    );
  }
}

export default compose(
  connect((_, ownProps) => {
    return {
      form: ownProps.formName || 'logo_uploader',
    };
  }),
  reduxForm({
    enableReinitialize: true,
  })
)(LogoUploaderForm);
